import { IconButton, Badge, Tooltip } from '@mui/material';
import { Notifications as NotifIcon } from '@mui/icons-material';
import { getColor } from '@assets/theme';
import { AppNotif } from '@interfaces/module.interface';
import { usePopover } from '@hooks/usePopover';
import NotificationPopoverList from './notification-popover-list';
import { useGetNotificationListQuery } from '@api/notification/notification.api.rtk';
import { useCurrentModule } from '@hooks/useCurrentModule';

/**
 * Notifications component
 *
 * This component displays a notification icon with a badge showing the number of notifications.
 * When clicked, it opens a popover with a list of notifications.
 *
 * @param {Object} props - The component props
 * @param {string} props.color - The color of the notification icon
 * @returns {JSX.Element} The rendered Notifications component
 */
const Notifications = ({ color }: AppNotif) => {
  // Get the current module from the Redux store
  const currentModule = useCurrentModule();

  // Fetch notification data for the current module
  const { data } = useGetNotificationListQuery(currentModule);

  // Get color values from the theme
  const { danger, white } = getColor();

  // Use the custom popover hook
  const { PopoverWrapper, handleToggle, anchorRef } = usePopover();

  return (
    <>
      <Tooltip title='Notifications'>
        <IconButton
          id='header-notifications'
          sx={{
            border: 0,
            ':hover': { bgcolor: 'unset' },
            bgcolor: 'transparent',
          }}
          disableRipple
          ref={anchorRef}
          onClick={handleToggle}
        >
          <Badge
            badgeContent={data?.data?.notifications?.length}
            sx={{
              '.MuiBadge-badge': {
                background: danger,
                color: white,
              },
            }}
          >
            <NotifIcon sx={{ color: color || white, fontSize: '24px' }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <PopoverWrapper
        placement='bottom-end'
        headerTitle='Notification'
        sx={{
          '.MuiPaper-root': { marginTop: '25px' },
        }}
      >
        <NotificationPopoverList notificationData={data?.data} />
      </PopoverWrapper>
    </>
  );
};

export default Notifications;
